import { render, staticRenderFns } from "./HomeScreen.vue?vue&type=template&id=1dc43661&scoped=true&"
import script from "./HomeScreen.vue?vue&type=script&lang=js&"
export * from "./HomeScreen.vue?vue&type=script&lang=js&"
import style0 from "./HomeScreen.vue?vue&type=style&index=0&id=1dc43661&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc43661",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VLayout})
